/** 선택(체크박스) 컬럼 너비 */
export const COLUMN_MIN_WIDTH = 42;
export const COLUMN_MIN_HEIGHT = 34;
export const EXPAND_COLUMN_WIDTH = 52;
export const SCROLL_MAX_HEIGHT = 600;
/** 선택 컬럼 너비(42) - 체크박스 너비(18) 를 좌우로 나눈 값 */
export const TABLE_CONTROL_CELL_HORIZONTAL_PADDING = 12;
export const TABLE_HEAD_LABEL_GAP = 4;
export const TABLE_EXPAND_ICON_SIZE = 12;
export const TABLE_CONTROL_HEADER_VERTICAL_PADDING = 7;
